import React from 'react';
import { useTranslation } from 'react-i18next';
import { FatalErrorNotice, FATAL_ERROR_NOTICE_TYPES, BodyText } from '@kallidus/common';
import ApplicationPage from '@Generic/ApplicationPage';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <ApplicationPage className='kal-error-page'>
      <FatalErrorNotice
        subHeading={t('not-found-page.heading')}
        type={FATAL_ERROR_NOTICE_TYPES.NOT_FOUND}
        heading={t('not-found-page.title')}
      >
        <BodyText noTopSpacer>{t('not-found-page.message')}</BodyText>
      </FatalErrorNotice>
    </ApplicationPage>
  );
}
